export class DecoratorUtils {
  public static debounce(ms: number) {
    return (
      target: unknown,
      propertyKey: string,
      descriptor: PropertyDescriptor,
    ): void => {
      let timer: ReturnType<typeof setTimeout>;
      const originalMethod = descriptor.value;
      descriptor.value = function (...args: any[]) {
        if (timer) clearTimeout(timer);
        timer = setTimeout(() => {
          originalMethod.apply(this, args);
        }, ms);
      };
    };
  }
}
